import { MenuItem, ListItemText, Typography, Tooltip } from "@mui/material";
import dayjs from "dayjs";
import { NotificationProps } from "../common/redux/notificationActions";
import { NotifMessage, NotifTitle } from "./styled";

const NotificationItem = ({
    notification,
    onClick,
}: {
    notification: NotificationProps;
    onClick: (notification: NotificationProps) => void;
}) => {
    return (
        <MenuItem
            onClick={() => onClick(notification)}
            sx={{
                backgroundColor: notification.read ? "white" : "#ffe6e6",
                borderLeft: notification.read ? "none" : "3px solid #ff6f61",
                borderBottom: "1px solid #eee",
                maxWidth: "380px",
                whiteSpace: "normal",
            }}
        >
            <ListItemText
                primary={<NotifTitle>{notification.title}</NotifTitle>}
                secondary={
                    <>
                        <NotifMessage>{notification.body}</NotifMessage>
                        <Tooltip
                            title={dayjs(notification.createdAt).format(
                                "dddd, D MMMM YYYY HH:mm"
                            )}
                        >
                            <Typography variant="caption">
                                {dayjs(notification.createdAt)
                                    .local()
                                    .format("DD/MM/YYYY à HH:mm")}
                            </Typography>
                        </Tooltip>
                    </>
                }
            />
        </MenuItem>
    );
};

export default NotificationItem;
